import PageTitle from "@/components/PageTitle";
import IconifyIcon from "@/components/wrappers/IconifyIcon";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

/**
 * ArchivedAdminFeature - graceful landing for admin routes retired by the
 * Ilmaivo pivot (course marketplace -> session booking). The underlying
 * page code and data are preserved; only the surface is hidden from
 * navigation. Old bookmarks / deep links land here instead of a 404 or a
 * broken page, with a link back to the dashboard.
 */
const ArchivedAdminFeature = ({
  title = "Feature Retired",
  message = "This feature has been retired as part of the Ilmaivo pivot.",
}) => {
  return (
    <>
      <PageTitle title={title} />
      <Row className="justify-content-center">
        <Col lg={5}>
          <div className="text-center py-5">
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-3 bg-light mb-3"
              style={{ width: 56, height: 56 }}
            >
              <IconifyIcon icon="tabler:archive" className="fs-24 text-muted" />
            </div>
            <h4 className="mt-2 mb-2">{title}</h4>
            <p className="text-muted mb-4">{message}</p>
            <Link className="btn btn-primary" to="/dashboard">
              <IconifyIcon icon="tabler:home" className="me-1" /> Back to Dashboard
            </Link>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ArchivedAdminFeature;
